// extracted by mini-css-extract-plugin
export var card = "_jq-5";
export var cardSelected = "_jq-4";
export var image = "_jq-3";
export var modal = "_jq-0";
export var modalContent = "_jq-1";
export var table = "_jq-2";